<template>
  <div>
    <div class="container" style="border-radius: 15px">
      <div class="columns">
        <div class="column">
          <div class="title is-5">
            Becas de estudio
            <hr class="dropdown-divider" aria-role="menuitem">
          </div>
          <div class="columns">
            <div class="column">
                    <span class="is-pulled-right">
                        <button class="button is-primary" @click="newScholarship()">
                            <b-icon icon="plus"></b-icon>
                            <span>Agregar Beca de Estudio</span>
                        </button>
                    </span>
            </div>
          </div>
        </div>
      </div>
      <b-table
          :data="scholarships"
          :paginated=true
          per-page=10
          :current-page="currentPage"
          :card-layout="cardLayout"
          :pagination-simple=false
          pagination-position="bottom"
          aria-next-label="Siguiente"
          aria-previous-label="Anterior"
          aria-page-label="Página"
          aria-current-label="Página actual">
        <b-table-column
            field= 'name'
            label= 'Carácter de la beca'
            searchable
            sortable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{ props.row.name }}
          </template>
        </b-table-column>
        <b-table-column
            field= 'partner_entity_name'
            label= 'Organismo otorgante'
            searchable
            sortable
        >
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            <div v-if="props.row.partner_entity_name != null">{{ props.row.partner_entity_name }}</div>
            <div v-else></div>
          </template>
        </b-table-column>
        <b-table-column
            field= 'study'
            label= 'Estudios'
            searchable
            sortable
        >
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            <div v-if="props.row.study != null">{{ props.row.study}}</div>
            <div v-else></div>
          </template>
        </b-table-column>
        <b-table-column
            field= 'institution_name'
            label= 'Institución'
            searchable
            sortable
        >
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            <div v-if="props.row.institution_name != null">{{ props.row.institution_name }}</div>
            <div v-else></div>
          </template>
        </b-table-column>
        <b-table-column
            field= 'start_date'
            label= 'Fecha de inicio'
            searchable
            :custom-search="searchInitDate"
            sortable
        >
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{ props.row.start_date._isValid ? new Date(props.row.start_date).toLocaleDateString("es-CL")  : "" }}
          </template>
        </b-table-column>
        <b-table-column
            field= 'end_date'
            label= 'Fecha de término'
            searchable
            :custom-search="searchEndDate"
            sortable
        >
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{ props.row.end_date._isValid ? new Date(props.row.end_date).toLocaleDateString("es-CL")  : "" }}
          </template>
        </b-table-column>
        <b-table-column
            label="Acciones"
            v-slot="props">
          <b-icon
              pack="fas"
              icon="eye"
              size="is-medium"
              @click.native="showModal(props.row)"/>
          <b-icon
              pack="fas"
              icon="edit"
              size="is-medium"
              @click.native="editModal(props.row)"/>
        </b-table-column>
        <template slot="empty" slot-scope="props">
          <div class="columns is-centered">
            <div class="column is-6 is-centered has-text-centered">
              <!--              <b-message v-if="can_edit" has-icon type="is-warning">
                              <h1> No se encontraron resultados, haga click <a @click="newParticipant()">aquí</a> para relacionar entidades.</h1>
                            </b-message>-->
              <b-message has-icon type="is-warning">
                <h1> No se encontraron resultados.</h1>
              </b-message>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
    <b-modal
        v-model="isModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        width="90%"
        aria-role="dialog"
        aria-modal
        :can-cancel="false">
      <template #default="props">
        <modal_new_scholarship
            :person-id="personId"
            :update="update"
            :old_scholarship="old_scholarship"
            @close="props.close"></modal_new_scholarship>
      </template>
    </b-modal>
    <b-modal
        v-model="isModalActiveShow"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        width="90%"
        aria-role="dialog"
        aria-modal
        :can-cancel="false">
      <template #default="props">
        <modal_show_scholarship
            :person-id="personId"
            :old_scholarship="old_scholarship"
            @close="props.close"></modal_show_scholarship>
      </template>
    </b-modal>
  </div>
</template>

<script>
import modal_new_scholarship from "./modal_new_scholarship";
import modal_show_scholarship from "./modal_show_scholarship";
import {searchDate} from "../../packs/utilities";
import axios from "axios";
import moment from "moment";
export default {
  name: "scholarships_data_tab",
  components:{modal_show_scholarship,modal_new_scholarship},
  props:['personId'],
  data(){
    return{
      isLoading: false,
      scholarships: [],
      old_scholarship:{},
      isModalActive: false,
      isModalActiveShow: false,
      update:false,
      currentPage: 1,
      cardLayout: false,
    }
  },
  created(){
    this.getScholarships()
  },
  methods:{
    getScholarships(){
      this.isLoading = true
      this.update = false
      this.old_scholarship = {}
      axios
          .get('/my-scholarships/'+this.personId+'.json')
          .then(response =>{
            this.scholarships = response.data
            this.scholarships = this.scholarships.map(scholarship =>{
              var newScholarship = scholarship
              newScholarship["start_date"] =  moment(newScholarship["start_date"], ["YYYY-MM-DD","DD-MM-YYYY"]);
              newScholarship["end_date"] =  moment(newScholarship["end_date"], ["YYYY-MM-DD","DD-MM-YYYY"]);
              return newScholarship;
            })
            this.isLoading = false
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
    },
    newScholarship(){
      this.update =false
      this.isModalActive = true
    },
    showModal(dato){
      this.old_scholarship = dato
      this.isModalActiveShow = true
    },
    editModal(dato){
      this.update = true
      this.old_scholarship = dato
      this.isModalActive = true
    },
    searchInitDate(row,input){
      return searchDate(row.start_date,input)
    },
    searchEndDate(row,input){
      return searchDate(row.end_date,input)
    },
  },
  watch: {
    isModalActive: function () {
      if (!this.isModalActive) {
        this.getScholarships()
      }
    },
    isModalActiveShow: function () {
      if (!this.isModalActiveShow) {
        this.getScholarships()
      }
    },
  }
}
</script>

<style scoped>

</style>